var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"areyouhealthy"},[_vm._v(" Response code: "+_vm._s(_vm.response)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }